// ============================================
// F-06 扫码登录 API
// POST /auth/qr/issue   新端申请 ticket
// GET  /auth/qr/poll    新端轮询（confirmed 时返回 user+token）
// POST /auth/qr/scan    已登录端标记已扫码（可选）
// POST /auth/qr/confirm 已登录端确认
// ============================================
import client from './client';

export interface QrIssueResult {
  ticket: string;
  expiresIn: number;
}

export type QrPollResult =
  | { status: 'pending' | 'scanned' }
  | { status: 'expired' }
  | { status: 'confirmed'; user: unknown; token: string };

export async function issueQrLogin(): Promise<QrIssueResult> {
  const { data } = await client.post('/auth/qr/issue');
  return data;
}

export async function pollQrLogin(ticket: string): Promise<QrPollResult> {
  const { data } = await client.get('/auth/qr/poll', { params: { ticket } });
  return data;
}

export async function scanQrLogin(ticket: string): Promise<{ status: string }> {
  const { data } = await client.post('/auth/qr/scan', { ticket });
  return data;
}

export async function confirmQrLogin(ticket: string): Promise<{ status: string }> {
  const { data } = await client.post('/auth/qr/confirm', { ticket });
  return data;
}
